import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import settingsService, { PlatformSettings } from '../../services/settingsService';

interface SettingsState {
  settings: PlatformSettings | null;
  loading: boolean;
  error: string | null;
}

const initialState: SettingsState = {
  settings: null,
  loading: false,
  error: null,
};

// Async thunk to fetch platform settings
export const fetchPlatformSettings = createAsyncThunk(
  'settings/fetchPlatformSettings',
  async (_, { rejectWithValue }) => {
    try {
      const settings = await settingsService.getPublicSettings();
      return settings;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch platform settings');
    }
  }
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    clearSettings: (state) => {
      state.settings = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlatformSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlatformSettings.fulfilled, (state, action: PayloadAction<PlatformSettings>) => {
        state.loading = false;
        state.settings = action.payload ?? null;
        state.error = null;
      })
      .addCase(fetchPlatformSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
